import {gsap} from "gsap";
import TestimonialsSlider from "./views/slider/Slider";

const Testimonials = {

    init() {
        this.el = $('[module="testimonials"]');
        if (!this.el) return;

        TestimonialsSlider.init();
        this.filterForm = this.el.find('.filter form');
        this.button = this.el.find('.filter .button');
        this.form = this.el.find('.form');
        this.bind();
        this.Reviews.init(this.el);
    },


    bind() {
        this.filterForm.find('select').on('change', (evt, params) => {
            this.filterForm.submit();
        });

        this.button.click((evt) => {
            const el = $(evt.currentTarget);
            if (el.is('.open')) this.close(el)
            else this.open(el);
        })
    },

    open(el) {
        el.addClass('open');
        gsap.set(this.form, {height: 'auto'});
        gsap.from(this.form, {
            height: 0, duration: 0.3, onComplete: () => {
                gsap.set(this.form, {height: 'auto'});
            }
        });
    },

    close(el) {
        el.removeClass('open');
        gsap.to(this.form, {height: 0, duration: 0.3});
    },

    Reviews: {
        textHeight: 70,

        init(el) {
            this.el = el.find('[element="review"]');
            this.button = this.el.find('.button');
            if (window.innerWidth < 640) this.textHeight = 50;
            this.prepare();
            this.bind();
        },

        prepare() {
            this.el.each((i, el) => {
                const text = $(el).find('.holder p');
                if (text.innerHeight() > this.textHeight) {
                    $(el).find('.button').addClass('visible');
                    text.addClass('ellipsis');
                }
            })
        },

        bind() {
            this.button.click((evt) => {
                const el = $(evt.currentTarget);
                if (el.is('.open')) this.close(el)
                else this.open(el);
            })
        },

        open(el) {
            const holder = el.prev('.holder');
            holder.find('p').removeClass('ellipsis');
            el.addClass('open').attr('icon', 'remove').text(window.T.global.less);
            gsap.set(holder, {height: 'auto'});
            gsap.from(holder, {height: this.textHeight, duration: 0.3});
        },

        close(el) {
            const holder = el.prev('.holder');
            holder.find('p').addClass('ellipsis');
            el.removeClass('open').attr('icon', 'add').text(window.T.global.more)
            gsap.to(holder, {height: this.textHeight, duration: 0.3});
        }
    },


};

export default Testimonials;